'use strict';


export default angular.module('fplTruescapeComApp.mapPin', [])
  .directive('mapPin', function($rootScope, $compile, $timeout, $window, Modal, appConfig) {
    'ngInject';
    return {
      scope: {
        mapPin: '='
      },
      link: function($scope, $element) {
        // assign map controls to global so we can access mapboxGl.js methods
        var mapObject;
        $scope.$on('mapboxglMap:load', function(evt, map) {
          mapObject = map.target;
        });

        $scope.sectorsEnabled = appConfig.siteSectorsEnabled;

        // adding hover efferct (font-icon swap) to map pins
        $element.attr('ng-mouseenter', 'hover = true');
        $element.attr('ng-mouseleave', 'hover = false');

        function _resetMap() {
          let coords = {
            lat: 26.859655,
            lng: -81.154691
          };
          let lngLat = new $window.mapboxgl.LngLat(coords.lng, coords.lat);
          mapObject.flyTo({
            center: lngLat,
            zoom: 7,
            pitch: 55,
            bearing: 35,
            speed: 0.75, // make the flying slow
            curve: 1, // change the speed at which it zooms out
            easing: function(t) {
              return t;
            }
          });
        }

        function _openModal(instance) {
          Modal.custom.map(instance).then(_resetMap, _resetMap);
        }

        $scope.clickHandler = function() {
          let instance = $scope.marker;
          if(mapObject && mapObject.getZoom() < 8) {
            // Eeek, magic number for demo
            let lng = $scope.marker.coordinates[0];
            let lat = $scope.marker.coordinates[1];
            let lngLat = new $window.mapboxgl.LngLat(lng, lat);
            mapObject.flyTo({
              // These options control the ending camera position: centered at
              // the target, at zoom level 7, looking in a random direction.
              center: lngLat,
              zoom: 7,
              pitch: 60, //60,
              bearing: 55, //45,

              // These options control the flight curve, making it move
              // slowly and zoom out almost completely before starting
              // to pan.
              speed: 0.5, // make the flying slow
              curve: 1, // change the speed at which it zooms out

              // This can be any easing function: it takes a number between
              // 0 and 1 and returns another number between 0 and 1.
              easing: function(t) {
                return t;
              }
            });
            let moveEndListener = $scope.$on('mapboxglMap:moveend', function() {
              $timeout(() => {
                _openModal(instance);
              }, 0);
              moveEndListener();
            });
          } else {
            _openModal(instance);
          }
        };
        $scope.$watch('mapPin', newVal => {
          if(!_.isEmpty(newVal)) {
            $scope.marker = $scope.mapPin;
            // adding hover icon-swap to each pin
            if($scope.sectorsEnabled) {
              $element.attr('ng-class', '{"icon-' + $scope.mapPin.site.sector + '-hover": hover}');
            } else {
              $element.attr('ng-class', '{"icon-solar-hover": hover}');
            }
            $element.attr('ng-click', 'clickHandler()');
            $compile($element)($scope);
          }
        });
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/mapPin/mapPin.directive.js